module.exports = __webpack_public_path__ + "static/img/住院缴费@3x.c56f7c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/butler/住院缴费@3x.png
// module id = 803
// module chunks = 382